var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waggon-info color-3 t-rounded t-shadow"},[_c('div',{staticClass:"waggon-info-header"},[_vm._t("header",null,{"waggon":_vm.waggon})],2),_c('div',{staticClass:"waggon-info-body"},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }